<!-- VCN系统列表页面 -->
<template>
  <div class="visitor-area-container section-main__warp1">
    <div class="flex-row tree-list-area" style="height: 100%">
      <!-- 左侧树 -->
      <div class="area-tree-left page-background-color">
        <el-scrollbar class="scroll-bar">
          <el-tree
            ref="tree"
            class="tree-content"
            :data="areaTreeData"
            :expand-on-click-node="false"
            node-key="areaDevGroupCode"
            :default-expanded-keys="treeExpandData"
            render-after-expand
            :props="defaultProps"
            :highlight-current="true"
            :filter-node-method="filterNode"
            @node-click="nodeClick"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span :class="data.isDelete ? 'line-through' : ''">{{
                node.label
              }}</span>
              <span v-if="!data.isEdit">({{ data.aliasName }})</span>
              <el-input
                class="alias-input"
                v-if="
                  data.isEdit && areaDetailsInfo.id === data.areaDevGroupCode
                "
                v-model="nickName"
                @change="handleName(data)"
                @blur="handleName(data)"
                @keyup.enter.native="handleName(data)"
                placeholder="请输入内容"
              ></el-input>
              <span v-if="areaDetailsInfo.id === data.areaDevGroupCode">
                <div class="area-operator" @click="addClick">
                  <el-button
                    v-if="!data.isDelete"
                    type="text"
                    class="el-icon-delete-solid"
                    size="mini"
                    @click="() => removeArea(node, data)"
                  ></el-button>
                  <el-button
                    v-if="data.isDelete"
                    type="text"
                    icon="iconfont-lunan icon-lunan-web-icon-"
                    size="mini"
                    @click="() => recoveryArea(node, data)"
                  ></el-button>
                  <el-button
                    v-if="!data.isEdit"
                    type="text"
                    class="el-icon-edit-outline"
                    size="mini"
                    @click="() => editArea(node, data)"
                  ></el-button>
                </div>
              </span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
      <!-- 右侧表格 -->
      <div class="table-area page-background-color">
        <div class="table-head">
          <div class="head-title"><span>设备名称</span></div>
          <div class="head-title"><span>全设备类型</span></div>
        </div>
        <el-scrollbar class="scrolltable-bar">
          <div
            class="table-content"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <div class="content-left">
              <span :class="item.isConfig === '1' ? 'line-through' : ''">{{
                item.thirdDeviceName
              }}</span>
            </div>
            <div class="content-middle">
              <span :class="item.isConfig === '1' ? 'line-through' : ''">{{
                item.deviceType | deviceTypeFilter
              }}</span>
            </div>
            <el-button
              v-if="item.isConfig === '0' || item.isConfig === null"
              type="text"
              class="el-icon-delete-solid operate-btn"
              size="mini"
              @click="deleteItem(item, index)"
            ></el-button>
            <el-button
              v-else
              type="text"
              class="operate-btn"
              icon="iconfont-lunan icon-lunan-web-icon-"
              size="mini"
              @click="() => recoveryItem(item, index)"
            ></el-button>
          </div>
        </el-scrollbar>
        <div class="bottom-btn">
          <el-button type="primary" @click="submitData()">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Dic } from "$utils";
import { api } from "../api";

export default {
  props: {
    areaType: String,
  },
  filters: {
    // 主设备类型
    deviceTypeFilter(el) {
      return Dic.findByValue("SENU086", el || el);
    },
  },
  data() {
    return {
      // 区域树对象
      areaTreeData: [],
      defaultProps: {
        children: "subAreaDevGroupList",
        label: "areaDevGroupName",
      },
      // 展开的节点id
      treeExpandData: [],
      areaDetailsInfo: {},
      isTopTreeNode: true,
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 0,
        pageSize: 10,
      },
      nickName: "",
      isShowInput: false,
      tableData: [],
      areaDevGroupCode: "",
    };
  },
  created() {},
  mounted() {
    this.getAreaTree(this.areaType);
  },
  methods: {
    getAreaTree(type) {
      let params = {
        treeType: type,
      };
      this.$fetch(api.deviceMan.getAreaConfigTree, params).then((res) => {
        if (res.success) {
          this.areaTreeData = this.handleData(res.returnObj);
          this.areaDevGroupCode = this.areaTreeData[0].areaDevGroupCode;
          this.getRoleTreeRootNode(this.areaDevGroupCode);
          this.$nextTick(function () {
            this.$refs.tree.setCurrentKey(this.areaDevGroupCode);
            this.getTableData();
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 获取树形结构默认展开第一级节点
    getRoleTreeRootNode(code) {
      this.treeExpandData.push(code);
    },
    getTableData() {
      let params = {
        treeType: this.areaType,
      };
      this.$fetch(api.deviceMan.getDeviceConfigList, params).then((res) => {
        if (res.success) {
          this.tableData = res.returnObj;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handleData(data) {
      const self = this;
      data.forEach((item, index) => {
        item.isDelete = false;
        item.isEdit = false;
        item.subAreaDevGroupList.forEach(() => {
          self.handleData(item.subAreaDevGroupList);
        });
      });
      return data;
    },
    // 单击节点时
    nodeClick(data) {
      this.isTopTreeNode = data.parentCode !== "-1" ? false : true;
      let parentNode = this.$refs.tree.getNode(data.parentCode);
      this.areaDetailsInfo = {
        id: data.areaDevGroupCode,
        name: data.areaDevGroupName,
        lng: data.lng,
        lat: data.lat,
        parentName: "",
        personList: data.personList,
        ownerList: data.ownerList,
        desc: data.desc,
      };
      if (parentNode && parentNode.data) {
        this.areaDetailsInfo.parentName = parentNode.data.areaDevGroupName;
      }
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    addClick(event) {
      event.stopPropagation();
    },

    removeArea(node, data) {
      data.isDelete = true;
      data.isConfig = "1";
    },
    recoveryArea(node, data) {
      data.isDelete = false;
      data.isConfig = "0";
    },

    editArea(node, data) {
      console.log("树的node++++", node);
      console.log("树的data++++", data);
      this.nickName = "";
      this.isShowInput = true;
      data.isEdit = true;
    },
    handleName(data) {
      data.isEdit = false;
      if (this.nickName !== "") {
        data.aliasName = this.nickName;
      }
      // data.isConfig = "1";
    },
    deleteItem(data, i) {
      // this.$confirm("您确定删除该设备吗?", "确认", {
      //   confirmButtonText: "确认",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // }).then(() => {
      //   this.tableData.splice(i, 1);
      // });
      data.isConfig = "1";
    },
    recoveryItem(data, index) {
      data.isConfig = "0";
    },
    submitData() {
      this.$confirm("您确定保存更改么?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let areaTreeDataCopy = [];
        areaTreeDataCopy = this.menusDataPro2(this.areaTreeData);
        let params = {
          treeType: this.areaType,
          areaDevGroupList: areaTreeDataCopy,
          deviceInfoList: this.tableData,
        };
        console.log("提交的参数666666666", params);
        this.$fetch(api.deviceMan.updateConfig, params).then((res) => {
          if (res.success) {
            this.$message.success(res.msgContent);
            this.getAreaTree(this.areaType);
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    menusDataPro2(data) {
      const self = this;
      if (data !== null) {
        data.forEach(function (item) {
          delete item.isDelete;
          delete item.isEdit;
          if (item.subAreaDevGroupList && item.subAreaDevGroupList.length) {
            item.subAreaDevGroupList = self.menusDataPro2(
              item.subAreaDevGroupList
            );
          }
        });
        return data;
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.visitor-area-container {
  width: 100%;
  height: 100%;
  // 更改树组件默认样式
  .area-tree-left {
    padding: 20px;
    max-height: 100%;
    overflow: hidden;
    width: 360px;
    .scroll-bar {
      @include set_theme_color(background-color, top-menu-bg-color);
      height: calc(100% - 0px);
      .el-scrollbar__wrap {
        // overflow-x: hidden;
        height: calc(100% + 17px);
        .el-scrollbar__view {
          display: inline-block;
          min-width: 100%;
        }
      }
    }
    .area-operator {
      display: inline-block;
      margin-left: 20px;
    }
    .tree-content {
      width: fit-content;
      min-width: 100%;
      .el-tree-node__label {
        display: inline-block;
        max-width: 80%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .tree-header {
      position: relative;
      background: #3f629c;
      color: #fff;
      font-weight: bold;
      font-size: 13px;
      .area-name {
        padding-left: 10px;
      }
    }
    .custom-info {
      position: absolute;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .area-name {
      width: 80%;
    }
    .operate-btns {
      width: 20%;
      text-align: center;
      right: 10px;
    }
  }
  .el-tree-node__content {
    height: 40px;
    line-height: 40px;
    &:hover {
      background: rgb(45, 73, 118);
    }
    .custom-tree-node {
      width: 100%;
      height: 40px;
      line-height: 40px;
      .line {
        display: inline-box;
        height: 2px;
        width: 40px;
        background-color: red;
      }
      .alias-input {
        width: 135px;
        border: 1px solid #161b29;
        margin-left: 10px;
      }
    }
    &:before {
      margin-top: -26px !important;
    }
  }
  .table-area {
    margin: 10px;
    max-height: 100%;
    height: calc(100% - 45px);
    overflow: hidden;
    width: 400px;
    background-color: #161b29;
    .table-head {
      display: flex;
      flex-direction: row;
      background-color: #262b37;
      width: 400px;
      height: 50px;
      .head-title {
        flex: 1;
        line-height: 50px;
        text-align: center;
      }
    }
    .scrolltable-bar {
      background-color: #121722 !important;
      height: calc(100% - 230px);
      .el-scrollbar__wrap {
        overflow-x: hidden;
        height: calc(100% - 0px);
        .el-scrollbar__view {
          display: inline-block;
          min-width: 100%;
        }
      }
    }
    .table-content {
      display: flex;
      flex-direction: row;
      background-color: #262b37;
      width: 400px;
      height: 40px;
      div {
        flex-grow: 2;
        line-height: 40px;
        text-align: center;
      }
      .operate-btn {
        // flex-grow: 1;
        width: 60px;
      }
      &:nth-child(odd) {
        background-color: #0d121c;
      }
      &:nth-child(even) {
        background-color: #121722;
      }
      &:hover {
        background-color: #080b10;
      }
    }
    .bottom-btn {
      text-align: right;
      background-color: #121722;
      height: 50px;
      line-height: 50px;
    }
  }
  .line-through {
    text-decoration: line-through red;
  }
}
</style>
